// extracted by mini-css-extract-plugin
export default {"recommendedFixingDaysItem":"FailureViewDetailsSection_recommendedFixingDaysItem__o3kk1"};